module.exports = __webpack_public_path__ + "img/maxtrek.61b28feb.png";